
	import { formatDateTime } from "@/domain/entities/EntityFields";
	import { defineComponent, ref } from "vue";
	import MeasurementScheduleForm from "@/components/MeasurementScheduleForm.vue";
	import MeasurementScheduleList from "@/components/MeasurementScheduleList.vue";
	import useDoctor from "@/store/DoctorState";
	import useNotification from "@/store/NotificationState";
	import { useRouter } from "vue-router";
import { MedicalBackground } from "@/domain/entities/MedicalBackground";
import { AllergiesQuestionID } from "@/domain/entities/MedicalQuestion";

	export default defineComponent({
		components: {
			MeasurementScheduleForm,
			MeasurementScheduleList,
		},
		props: {
			patient: Object,
		},
		setup(props) {
			const { sendVideoCallRequest } = useDoctor();
			const { showSnackbar } = useNotification();
			const router = useRouter();
			const openScheduleForm = ref(false);
			const showHealthInformation = ref(false);
			async function onVideoCallClick() {
				try {
					let id = await sendVideoCallRequest();
					router.push({ path: "/call", query: { id } });
				} catch (err) {
					showSnackbar(err);
				}
			}
			const noAllergiesText = 'No tiene alergias';
			let allergies = ref<string>(noAllergiesText);
			let matchedQuestionItems : MedicalBackground[] = props.patient?.healthBackground.filter((hb : MedicalBackground) => hb.question === AllergiesQuestionID);
			if (matchedQuestionItems.length > 0) {
				allergies.value = matchedQuestionItems[0].answer.toUpperCase() === 'SI' ? (matchedQuestionItems[0].extraAnswer || '') : 'No tiene alergias'
			}


			return {
				formatDateTime,
				openScheduleForm,
				onVideoCallClick,
				showHealthInformation,
				allergies,
			};
		},
	});
